import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import SectionTitle from '@/checkout-instore-legacy/components/Commons/Elements/SectionTitle'

const FixedPayments = ({
  fixedPayments,
  payments,
  remainingValue,
  success,
}) => {
  remainingValue = remainingValue || 0

  if (success) {
    return null
  }

  if (!fixedPayments || fixedPayments.length === 0) {
    return null
  }

  const messageElm =
    remainingValue === 0 && payments.length === 0 ? (
      <SectionTitle contentClassName="flex">
        <FormattedMessage id="allValueWasPaid" />
      </SectionTitle>
    ) : payments.length === 0 ? (
      <SectionTitle contentClassName="flex">
        <FormattedMessage id="addPaymentsToFinishSale" />
      </SectionTitle>
    ) : null

  return <div className="mb5">{messageElm}</div>
}

FixedPayments.propTypes = {
  fixedPayments: PropTypes.arrayOf(PropTypes.object).isRequired,
  payments: PropTypes.arrayOf(PropTypes.object).isRequired,
  remainingValue: PropTypes.number,
  success: PropTypes.bool,
}

export default FixedPayments
